
<template>
  <div class="reset-oa-box">
    <div class="input_box">
      <span class="lable">*</span>
      <span class="label-txt">单据编号：</span>
      <Input class="ref_input" v-model="inputValue" placeholder="请输入单据编号" />
    </div>
    <div class="pop-btn">
      <Button class="cancel-btn" @click="cancel">
        <span>{{ chineseName.CANCEL }}</span>
      </Button>
      <Button type="error" class="sav-btn" @click="save">
        <span>{{ chineseName.CONFIRM }}</span>
      </Button>
    </div>
  </div>
</template>

<script>
import ChineseDictionary from '@/assets/js/ChineseDictionary';
export default {
  name: 'ResetOA',
  inject: ['moduleComponentName', 'instanceRouteQuery', 'instanceRoute'],
  data() {
    return {
      inputValue: '',
    };
  },
  created() {
    this.chineseName = ChineseDictionary;
  },
  activated() { },
  destroyed() { },
  methods: {
    save() {
      if (!this.inputValue.trim()) {
        const data = {
          mask: true,
          title: '警告',
          content: '请输入单据编号',
        };
        this.$Modal.fcWarning(data);
        return;
      }

      //   return;
      this.$network.get('/p/cs/oalogRePush', {
        params: { 'billNo': this.inputValue }
      }).then((res) => {
        if (res.data.data.code == 0) {
            this.$Modal.fcSuccess({
              title: '成功',
              content: '重推成功',
            });
          this.$emit('closeActionDialog', true); // 关闭弹框
        } else {
          this.$Modal.fcError({
            title: '失败',
            content: res.data.data.message,
          });
          this.$emit('closeActionDialog', true); // 关闭弹框
        }
      });
    }, // 确定
    cancel() {
      this.$emit('closeActionDialog', false); // 关闭弹框
    }, // 取消
  },
};
</script>

<style lang="less">
.reset-oa-box {
  .input_box {
    display: flex;
    flex-direction: row;
    align-items: center;
    .lable {
      //   padding-top: 12px;
      padding-right: 6px;
      color: red;
    }
    .label-txt {
      display: inline-block;
      width: 80px;
    }
  }
  .ref_input {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .pop-btn {
    display: flex;
    flex-direction: row-reverse;

    .cancel-btn {
      margin-left: 10px;
    }
  }
}
</style>